/**
 * router name 为大驼峰
 */

const accountRouter = [
	// 订单页
	{
		path: '/account/orders',
		name: 'AccountOrders',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/orders/index')
	},
	// 邀请页
	{
		path: '/account/users/current',
		name: 'AccountCurrent',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/invitation')
	},
	{
		path: '/account/privacy',
		name: 'AccountPrivacy',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/privacy')
	},
	{
		path: '/account/users',
		name: 'AccountUsers',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/users')
	},
	// 个人中心设置
	{
		path: '/account/settings',
		name: 'AccountSettings',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/settings')
	},
	// 会员购买页面
	{
		path: '/account/users/buy_member',
		name: 'MemberPayment',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/user/buy_member')
	},
	// 问题反馈
	{
		path: '/feedbacks/new',
		name: 'FeedbackNew',
		component: () => import(/* webpackChunkName: "account" */ '@/views/feedback/feedback')
	},
  // 账号注销
  {
    path: '/account/chancel',
		name: 'AccountChancel',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/cancel/index')
  },
  // 账号注销协议
  {
    path: '/account/chancel_agreement',
    name: 'AccountChancelAgreement',
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/cancel/agreement')
  }
];
export default accountRouter;
